import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
function SurfaceGlow(t0) {
  const $ = _c(7);
  const {
    angle,
    className
  } = t0;
  let t1;
  if ($[0] !== angle) {
    t1 = {
      "--duration": 20,
      "--angle": angle
    };
    $[0] = angle;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = t1 as React.CSSProperties;
  let t3;
  if ($[2] !== className) {
    t3 = cn("animate-orbit pointer-events-none absolute size-10 rounded-full opacity-40 blur-2xl [--radius:48] md:[--radius:58] lg:[--radius:66]", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <div aria-hidden={true} style={t2} className={t3} />;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
export { SurfaceGlow };